<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <!-- 头部焦点图 -->
    <div class="topBanner">
      <div class="bannerBox">
        <banner v-bind:pageTypeId="pageTypeId"></banner>
      </div>
      <div class="xdd-calendar" :class="'ExamType' + ExamType">
        <div class="dayData" :class="{ no: !ksCon }">
          <div class="nowDay">
            <div>
              {{ getDay }}
              <span>周{{ week }}</span>
            </div>
          </div>
          <div class="dayData2">
            {{ getYear }}年{{ getMonth }}月<br />
            农历{{ nlMonth }}{{ nlDay }}
          </div>
          <div class="koContent">
            <el-carousel height="80px" :autoplay="false" trigger="click" @change="gekoContent">
              <el-carousel-item v-for="item,index in ksList" :key="index">
                <div class="item">
                  {{ item.ChineseName }}
                  <span>{{ item.EnglishName }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <xdd-calendar @change="changeDay" :ExamType="ExamType" />
        <div class="dayTips" v-if="dayTips">{{ "考试提醒：" + dayTips }}</div>
      </div>
    </div>
    <!-- banner end -->
    <div class="main">
      <!-- 练习系统 -->
      <div class="practiceSystem w1200">
        <div class="left">
          <div class="title">练习系统-套卷</div>
          <ul class="leftBox">
            <li>
              <router-link :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: '托福' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_01.png" /><span>托福</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: '雅思' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_02.png" /><span>雅思</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: 'GRE' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_03.png" /><span>GRE</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list',
                  query: { nav: 10, type: 'SAT' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_04.png" /><span>SAT</span>
              </router-link>
            </li>
          </ul>
          <div class="title">练习系统-单项</div>
          <ul class="leftBox">
            <li>
              <router-link :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: '托福' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_05.png" /><span>托福</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: '雅思' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_06.png" /><span>雅思</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: 'GRE' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_07.png" /><span>GRE</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{
                  path: '/practice_system_list2',
                  query: { nav: 11, type: 'SAT' },
                }">
                <img class="practiceSystem_img" src="../../assets/index/practiceSystem_08.png" /><span>SAT</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="right">
          <div class="title_2">全真模考系统</div>
          <router-link :to="{ path: '/languageTest', query: { nav: 5 } }">
            <img class="practiceSystem_img" src="../../assets/index/practiceSystem_vip.png" />
          </router-link>
        </div>
      </div>
      <!-- publicClass_index end -->
      <div class="courseClass_index clearfix w1200">
        <div class="title">
          课程专栏
          <span>
            <router-link :to="{ path: '/course_list', query: { nav: 8 } }">查看更多</router-link>
          </span>
        </div>
        <div class="main_list">
          <swiper :options="swiperOption1">
            <swiper-slide v-for="(items, index) in courseClase" :key="index">
              <router-link :to="{
                    path: 'course_details',
                    query: { Id: items.JumpUrl, nav: 8 },
                  }">
                <dl>
                  <dt><img :src="items.ImageArrays" width="100%" /></dt>
                  <dd class="dd1">
                    <h2>{{ items.Title }}</h2>
                    <div>
                      <p class="p1">
                        <span>{{ courseClase_p[index].classType }}</span>
                      </p>
                      <p class="p3">￥{{ courseClase_p[index].price }}</p>
                    </div>
                  </dd>
                  <!-- <dd class="dd2">
                      <p class="p2">
                        {{ courseClase_p[index].student.replace(/ /g, " #") }}
                      </p>
                      <h2>{{ items.Title }}</h2>
                      <p class="p2">
                        {{ items.Remark }}
                      </p>
                      <p class="p1">
                        <span>{{ courseClase_p[index].classType }}</span>
                      </p>
                      <p class="p4">立即学习</p>
                    </dd> -->
                </dl>
              </router-link>
            </swiper-slide>
            <div class="swiper-pagination swiper-pagination1" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="teacher_index">
        <div class="title w1200">
          师资介绍
          <!-- <span>
            <router-link :to="{ path: '/teacher_list', query: { nav: 1 } }">查看更多</router-link>
          </span> -->
        </div>
        <div class="teacher_list w1200">
          <swiper :options="swiperOption2">
            <swiper-slide class="theClass_li" v-for="(item, index) in teacherClass" :key="index">
              <dl>
                <dt>
                  <img :src="item.ImageArrays" />
                </dt>
                <dd>
                  <h2>{{ item.Title }}</h2>
                  <p class="p2" v-if="teacherClass_p[index].academic">
                    {{ teacherClass_p[index].academic }}
                  </p>
                </dd>
              </dl>
            </swiper-slide>
            <div class="swiper-pagination swiper-pagination2" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <!-- teacher_index emd -->
    </div>
    <my-modal ref="myModal">
      <template #modalMIddle>
        <div style="text-align: center">
          <img src="../../assets/index/practiceSystem_modal.png" alt="" class="modal_img" />
          <div>
            <div class="modal_desc_title">解锁练习</div>
            <div class="modal_desc_desc">
              购买任意正价课程即可解锁所有练习。<br />
              随时随地畅快练习。
            </div>
          </div>
        </div>
      </template>
      <template #modalFooter>
        <div class="footer_modal" @click="toList">立即购买</div>
      </template>
    </my-modal>
  </div>
</template>

<script>
  import Header from "../../components/header/Header.vue"; //公共头部

  import banner from "../../page2/banner/banner.vue"; //头部banner图
  import myModal from "../../components/myModal.vue";
  import xddCalendar from "../../components/xdd-calendar/xdd-calendar.vue";
  export default {
    components: {
      // 将组件隐射为标签,登陆弹窗
      Header,
      banner,
      myModal,
      xddCalendar,
    },
    metaInfo() {
      return {
        title: "启德考培在线 - 启德考培旗下在线课堂_出国考试在线培训_考培网校",
        meta: [{
            name: "keywords",
            content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程",
          },
          {
            name: "description",
            content: "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程.",
          },
        ],
      };
    },
    data() {
      return {
        swiperOption1: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination1',
            type: 'bullets',
            progressbarOpposite: false,
          },
          autoplay: {
            delay: 2500, // 每张幻灯片轮播的时间间隔（毫秒）
            disableOnInteraction: false, // 用户操作后是否停止自动轮播
          },
        },
        swiperOption2: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 20,
          pagination: {
            el: '.swiper-pagination2',
            type: 'bullets',
            progressbarOpposite: false,
          },
          autoplay: {
            delay: 2500, // 每张幻灯片轮播的时间间隔（毫秒）
            disableOnInteraction: false, // 用户操作后是否停止自动轮播
          },
        },
        positions: false,
        policyDtos: "",
        pageTypeId: 13,

        courseClase: [],
        courseClase_p: [],
        cur: 21,

        bigList: [],
        bigList_p: [],

        teacherClass: [],
        teacherClass_p: [],

        getYear: "", //选中年
        getMonth: "", //选中月
        getDay: "", //选中日
        nlMonth: "", //农历月
        nlDay: "", //农历日
        week: "", //星期
        ksCon: "", //考试内容
        kpType: "", //考试类型
        ksList: [],
        ExamType: null,
        dayTips: "", //提示文字
      };
    },
    created() {
      console.log("store", this.$store);
      //自动触发写入的函数
      let that = this;
      //热门课程
      // let courseClases = sessionStorage.getItem("courseClase");
      // that.courseClase = JSON.parse(courseClases);
      // if (that.courseClase) {
      //   var bobao = [];
      //   for (var i = 0; i < that.courseClase.length; i++) {
      //     bobao.push(JSON.parse(that.courseClase[i].MoreFieldsValue));
      //   }
      //   that.courseClase_p = bobao;
      // } else {
      this.courseList(26);
      // }
      // let teacherClasss = sessionStorage.getItem("teacherClass");
      // if (teacherClasss) {
      //   that.teacherClass = JSON.parse(teacherClasss);
      //   var bobao = [];
      //   for (var i = 0; i < that.teacherClass.length; i++) {
      //     bobao.push(JSON.parse(that.teacherClass[i].MoreFieldsValue));
      //   }
      //   that.teacherClass_p = bobao;
      // } else {
      this.teacherList(34);
      // }
    },
    beforeDestroy() {
      //在组件生命周期结束的时候销毁。
    },
    methods: {
      async changeDay(date) {
        console.log(date, "加载完成");
        let that = this;
        this.getYear = date.year; //选中年
        this.getMonth = date.month; //选中月
        this.getDay = date.day; //选中日
        this.nlMonth = date.IMonthCn;
        this.nlDay = date.IDayCn;
        let arr = [`日`, `一`, `二`, `三`, `四`, `五`, `六`];
        this.week = date.week == 7 ? arr[0] : arr[date.week];
        let nowDate = date.year + "-" + date.month + "-" + date.day;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/CalendarReminders?nowDate=" +
            nowDate
          )
          .then(function(res) {
            console.log(res.data.results, "resresres");
            if (res.data.results.length == 0) {
              that.ksList = []
              that.ksCon = "";
              that.kpType = "";
              that.dayTips = "";
              that.ExamType = null;
            }
            that.ksList = res.data.results;
            that.ksCon = res.data.results[0].ChineseName;
            that.kpType = res.data.results[0].EnglishName;
            that.ExamType = res.data.results[0].ExamType;
            that.dayTips = res.data.results[0].Remark;
          })
          .catch(function() {
            // console.log('错误');
          });
      },
      gekoContent(e) {
        let that = this;
        console.log(e, "e");
        that.ExamType = that.ksList[e].ExamType;
        that.dayTips = that.ksList[e].Remark;
      },
      //热门课程
      courseList(e) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=" + e
          )
          .then(function(response) {
            console.log(response, "response")
            that.courseClase = response.data.results;
            let courseClases = JSON.stringify(that.courseClase);
            sessionStorage.setItem("courseClase", courseClases);
            var bobao = [];
            for (var i = 0; i < that.courseClase.length; i++) {
              bobao.push(JSON.parse(that.courseClase[i].MoreFieldsValue));
            }
            that.courseClase_p = bobao;
          })
          .catch(function() {
            // console.log('错误');
          });
      },
      // 启德教师
      teacherList(e) {
        let that = this;
        this.$http
          .get(
            "https://schoolapi.eiceducation.com.cn/api/PageInfo?pageTypeId=" + e
          )
          .then(function(response) {
            that.teacherClass = response.data.results;
            let teacherClasss = JSON.stringify(that.teacherClass);
            sessionStorage.setItem("teacherClass", teacherClasss);
            var bobao = [];
            for (var i = 0; i < that.teacherClass.length; i++) {
              bobao.push(JSON.parse(that.teacherClass[i].MoreFieldsValue));
            }

            console.log(bobao);
            that.teacherClass_p = bobao;
          })
          .catch(function() {
            // console.log('错误');
          });
      },
      toList() {
        this.$router.push({
          path: "/course_list",
          query: {
            nav: 8,
          },
        });
      },
    },
  };
</script>

<style scoped>
  @import url("./index.css");

  .footer_modal {
    width: 160px;
    height: 42px;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    padding: 6px 0;
    box-sizing: border-box;
    text-align: center;
    background: linear-gradient(100deg, #ff7c71 0%, #ff3250 100%);
    border-radius: 30px;
    margin: 0 auto;
    margin-bottom: 74px;
    cursor: pointer;
  }

  .modal_img {
    margin: 34px 94px 0 94px;
  }

  .modal_desc_title {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
  }

  .modal_desc_desc {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin: 30px 94px 38px 94px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/index/index.vue